import { createSlice } from "@reduxjs/toolkit";
const initialState ={

}

const SliceGRNDetailValidator = createSlice({
  name: "GRNDetailValidator",
  initialState: { value: initialState },

  reducers: {
    GrnDetailValidator_Set: (state, action) => {
      state.value = action.payload;
    },

    GrnDetailValidator_Init: (state) => {
      state.value = initialState;
    },   
  },
});

export const {
  GrnDetailValidator_Set,
  GrnDetailValidator_Init
} = SliceGRNDetailValidator.actions;
export default SliceGRNDetailValidator.reducer;
